export default __webpack_public_path__ + "static/road_trip-9c52d504b3d763eddcc6956fd2d60af2.svg";